import { getFileExtension } from "@/lib/utils";
import { formatDateTime } from "@/lib/utils/formatters";

export interface BuildAttachmentInfoPartsParams {
  confirmed_at?: string | null;
  size?: string | null;
  filePath: string;
}

export function buildAttachmentInfoParts({
  confirmed_at,
  size,
  filePath,
}: BuildAttachmentInfoPartsParams): string[] {
  const parts: string[] = [];
  if (confirmed_at) {
    parts.push(formatDateTime(confirmed_at));
  }
  if (size != null && size !== "") {
    parts.push(size);
  }
  const extension = getFileExtension(filePath);
  if (extension) {
    parts.push(extension);
  }
  return parts;
}
